import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SimpleGrow from './SimpleGrow';
import ClientProvider from './client';
export default createDemo(import.meta.url, SimpleGrow, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/transitions/demos/simple-grow/SimpleGrow.tsx",
    "fileName": "SimpleGrow.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Switch from '@mui/material/Switch';\nimport Paper from '@mui/material/Paper';\nimport Grow from '@mui/material/Grow';\nimport FormControlLabel from '@mui/material/FormControlLabel';\n\nconst icon = (\n  <Paper sx={{ m: 1, width: 100, height: 100 }} elevation={4}>\n    <svg width=\"100\" height=\"100\">\n      <Box\n        component=\"polygon\"\n        points=\"0,100 50,00, 100,100\"\n        sx={(theme) => ({\n          fill: theme.palette.common.white,\n          stroke: theme.palette.divider,\n          strokeWidth: 1,\n        })}\n      />\n    </svg>\n  </Paper>\n);\n\nexport default function SimpleGrow() {\n  const [checked, setChecked] = React.useState(false);\n\n  const handleChange = () => {\n    setChecked((prev) => !prev);\n  };\n\n  return (\n    <Box sx={{ height: 180 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <FormControlLabel\n        control={<Switch checked={checked} onChange={handleChange} />}\n        label=\"Show\"\n      />\n      <Box sx={{ display: 'flex' }}>\n        <Grow in={checked}>{icon}</Grow>\n        {/* Conditionally applies the timeout prop to change the entry speed. */}\n        <Grow\n          in={checked}\n          style={{ transformOrigin: '0 0 0' }}\n          {...(checked ? { timeout: 1000 } : {})}\n        >\n          {icon}\n        </Grow>\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 50,
        "focusedLines": 15,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Switch from '@mui/material/Switch';\nimport Paper from '@mui/material/Paper';\nimport Grow from '@mui/material/Grow';\nimport FormControlLabel from '@mui/material/FormControlLabel';\n\nconst icon = (\n  <Paper sx={{ m: 1, width: 100, height: 100 }} elevation={4}>\n    <svg width=\"100\" height=\"100\">\n      <Box\n        component=\"polygon\"\n        points=\"0,100 50,00, 100,100\"\n        sx={(theme) => ({\n          fill: theme.palette.common.white,\n          stroke: theme.palette.divider,\n          strokeWidth: 1,\n        })}\n      />\n    </svg>\n  </Paper>\n);\n\nexport default function SimpleGrow() {\n  const [checked, setChecked] = React.useState(false);\n\n  const handleChange = () => {\n    setChecked((prev) => !prev);\n  };\n\n  return (\n    <Box sx={{ height: 180 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <FormControlLabel\n        control={<Switch checked={checked} onChange={handleChange} />}\n        label=\"Show\"\n      />\n      <Box sx={{ display: 'flex' }}>\n        <Grow in={checked}>{icon}</Grow>\n        {/* Conditionally applies the timeout prop to change the entry speed. */}\n        <Grow\n          in={checked}\n          style={{ transformOrigin: '0 0 0' }}\n          {...(checked ? { timeout: 1000 } : {})}\n        >\n          {icon}\n        </Grow>\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 33
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormControlLabel"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 34
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "control"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "Switch"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "checked"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "checked"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "onChange"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleChange"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            [
              "        ",
              [
                "span",
                "pl-e",
                "label"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Show",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 36
            },
            "      />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 37
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "display"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "flex",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 38
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grow"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "in"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "checked"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "icon"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              "</",
              [
                "span",
                "pl-c1 di-jsx",
                "Grow"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 39
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c",
                "/* Conditionally applies the timeout prop to change the entry speed. */"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 40
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grow"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 41
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "in"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "checked"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 42
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "style"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "transformOrigin"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "0 0 0",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 43
            },
            [
              "          ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              "(",
              [
                "span",
                "pl-smi di-jv",
                "checked"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "?"
              ],
              " { ",
              [
                "span",
                "di-op di-jv",
                "timeout"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1000"
              ],
              " } ",
              [
                "span",
                "pl-k di-pu",
                ":"
              ],
              " {})",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 44
            },
            "        >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 45
            },
            [
              "          ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "icon"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 46
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grow"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 47
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 50,
    "focusedLines": 15,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Switch",
      "@mui/material/Paper",
      "@mui/material/Grow",
      "@mui/material/FormControlLabel"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
